import Swal from "sweetalert2";

const throwErrorMessage = (message: string) => {
    Swal.fire({
        toast: true,
        icon: 'error',
        titleText: 'Error',
        text: message,
        showConfirmButton: false,
        timer: 4000,
        allowEscapeKey: true,
        background: '#fff',
        color: '#000',
        iconColor: '#ff6600',
        timerProgressBar: true,
        position: 'top-end',
        target: '.v-application',
    }).then(r => r)
}

export default throwErrorMessage;